import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ImageTaskParams, FeedVideoPayload } from '@/services/types';

interface GenerationState {
  imageParams: ImageTaskParams | null;
  videoParams: FeedVideoPayload | null;
}

const initialState: GenerationState = {
  imageParams: null,
  videoParams: null,
};

const generationSlice = createSlice({
  name: 'generation',
  initialState,
  reducers: {
    setEditImageParams(state, action: PayloadAction<ImageTaskParams>) {
      state.imageParams = action.payload;
    },
    clearEditImageParams(state) {
      state.imageParams = null;
    },
    setEditVideoParams(state, action: PayloadAction<FeedVideoPayload>) {
      state.videoParams = action.payload;
    },
    clearEditVideoParams(state) {
      state.videoParams = null;
    },
    resetToInitialState: () => initialState,
  },
});

export const {
  setEditImageParams,
  clearEditImageParams,
  setEditVideoParams,
  clearEditVideoParams,
  resetToInitialState: resetGenerationToInitialState,
} = generationSlice.actions;

export default generationSlice.reducer;
